import * as React from 'react';
import withStyles, { WithStyles, StyleRules, ClassNameMap } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles';
import { CircularProgress } from '@material-ui/core';
import {Typography} from '@material-ui/core';

const styles = (theme:Theme):StyleRules => ({
  container: {
    width: "100%",
    textAlign: "center",
    marginTop: 40
  },
  overlayContainer:{
      position: "absolute",
      zIndex: 10000,
      backgroundColor: "rgba(255,255,255,.25)",
      top: -50,
      left: 0,
      right: 0,
      bottom: 0
  },
  overlayInner: {
        width: "100%",
        textAlign: "center",
        paddingTop: 150 
  }
})

interface Props extends React.HTMLProps<HTMLDivElement>{
  text?: string
  size?: number
  thickness?: number
  textColor?: "inherit" | "primary" | "secondary" | "default" | "textSecondary" | "error" | undefined
  spinnerColor?: "inherit" | "primary" | "secondary" | undefined
  overlay?: boolean
}

type State = {
};

class LoadingView extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
  constructor(props:Props & WithStyles<keyof typeof styles>) {
    super(props, {})
    this.state = {}; 
  }

  // componentWillReceiveProps(newProps:Props & WithStyles<keyof typeof styles>){
  // }


  render () {


    const { classes }: { classes:ClassNameMap } = this.props
    const { text, size, thickness, textColor, spinnerColor, overlay } = this.props
    if(overlay){
        return (
        <div className={classes.overlayContainer + " loading"}>
        <div className={classes.overlayInner}>
            <div>
            <Typography color={textColor || "textSecondary"} variant="h6" gutterBottom>
                { text || "Loading" }
            </Typography>
            </div>
            <div>
            <CircularProgress color={spinnerColor || "inherit"} size={size || 50} thickness={thickness || 5} className={classes.progress} />
            </div>
        </div>
        </div>
        );

    } else {
        return (
        <div id="loading-view" className={classes.container}>
            <div>
            <Typography color={textColor || "textSecondary"} variant="h6" gutterBottom>
                { text || "Loading" }
            </Typography>
            </div>
            <div>
            <CircularProgress color={spinnerColor || "inherit"} size={size || 50} thickness={thickness || 5} className={classes.progress} />
            </div>
        </div>
        );
    }
  }
}

export default withStyles(styles)(LoadingView);
